// extracted by mini-css-extract-plugin
module.exports = {"link":"_2m_BcV","name":"_1waGar","image":"_3mPEyG"};